import type { RouteRecordRaw } from 'vue-router';

/**
 * Manufacturing web screens: work centers/resources, versioned production specifications (formula
 * lines) and versioned routes (operations) from M4 WP4.5a (DECISIONS.md ADR-053), plus production
 * order screens from M4 WP4.5b (ADR-056) added below without touching the WP4.5a routes above —
 * exactly the seam WP4.5a's own note anticipated. Kept in its own file per the parallel-work
 * convention established by `finance.ts`/`inventory.ts` — `router.ts` only spreads this array into
 * the app-shell `children`.
 */
export const manufacturingRoutes: RouteRecordRaw[] = [
  // ---- Work centers / resources --------------------------------------------------------------------
  {
    path: 'manufacturing/work-centers',
    name: 'manufacturing-work-centers',
    component: () => import('../pages/manufacturing/WorkCentersPage.vue'),
    meta: { requiresModule: 'manufacturing' },
  },
  {
    path: 'manufacturing/work-centers/:id',
    name: 'manufacturing-work-center-detail',
    component: () => import('../pages/manufacturing/WorkCenterDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'manufacturing' },
  },
  // ---- Production specifications -------------------------------------------------------------------
  {
    path: 'manufacturing/specifications',
    name: 'manufacturing-specifications',
    component: () => import('../pages/manufacturing/SpecificationsPage.vue'),
    meta: { requiresModule: 'manufacturing' },
  },
  {
    path: 'manufacturing/specifications/:id',
    name: 'manufacturing-specification-detail',
    component: () => import('../pages/manufacturing/SpecificationDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'manufacturing' },
  },
  {
    path: 'manufacturing/specifications/versions/:versionId',
    name: 'manufacturing-specification-version-detail',
    component: () => import('../pages/manufacturing/SpecificationVersionDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'manufacturing' },
  },
  // ---- Routes ---------------------------------------------------------------------------------------
  {
    path: 'manufacturing/routes',
    name: 'manufacturing-routes',
    component: () => import('../pages/manufacturing/RoutesPage.vue'),
    meta: { requiresModule: 'manufacturing' },
  },
  {
    path: 'manufacturing/routes/:id',
    name: 'manufacturing-route-detail',
    component: () => import('../pages/manufacturing/RouteDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'manufacturing' },
  },
  {
    path: 'manufacturing/routes/versions/:versionId',
    name: 'manufacturing-route-version-detail',
    component: () => import('../pages/manufacturing/RouteVersionDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'manufacturing' },
  },
  // ---- Production orders (WP4.5b) --------------------------------------------------------------
  {
    path: 'manufacturing/orders',
    name: 'manufacturing-orders',
    component: () => import('../pages/manufacturing/ProductionOrdersPage.vue'),
    meta: { requiresModule: 'manufacturing' },
  },
  {
    path: 'manufacturing/orders/:id',
    name: 'manufacturing-order-detail',
    component: () => import('../pages/manufacturing/ProductionOrderDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'manufacturing' },
  },
];
